import api from '../api/client';
import React from 'react';
import { Timeline, Card, Typography } from 'antd';
import PerfectScrollbar from 'react-perfect-scrollbar';

const { Text, Title } = Typography;

const ActivityTimeline = ({ activityLog }) => {
    return (
        <Card
        
            bordered={false}
            style={{
                height: '75vh', // Total card height
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            {/* Scrollable section */}

            <div style={{ flex: 1, overflow: 'hidden' }} className="shadow-md rounded-lg timeline-container">
                <PerfectScrollbar>
                    <div style={{ paddingRight: 10, paddingBottom: 10 }}>
                        <Timeline mode="left">
                            {activityLog && activityLog.length > 0 ? (
                                activityLog.slice(0, 100).map((log, index) => (
                                    <Timeline.Item
                                        key={index}
                                        color={
                                            log.action?.toLowerCase().includes('update')
                                                ? 'blue'
                                                : log.action?.toLowerCase().includes('purchased')
                                                ? 'orange'
                                                : log.action?.toLowerCase().includes('create')
                                                ? 'violet'
                                                : log.action?.toLowerCase().includes('fed')
                                                ? 'red'
                                                : 'green'
                                        }
                                    >
                                        <Title level={5} style={{ marginBottom: 0 }}>
                                            {log.title || 'No Title'}
                                        </Title>
                                        <Text type="secondary">{log.action}</Text>
                                        <br />
                                        <Text>
                                            By: <b>{log.user_name || 'Unknown'}</b>
                                        </Text>
                                        <br />
                                        <Text type="secondary">{new Date(log.timestamp).toLocaleString()}</Text>
                                    </Timeline.Item>
                                ))
                            ) : (
                                <Timeline.Item color="gray">
                                    <Text type="secondary">No activity logs found.</Text>
                                </Timeline.Item>
                            )}
                        </Timeline>
                    </div>
                </PerfectScrollbar>
            </div>
        </Card>
    );
};

export default ActivityTimeline;
